import React from 'react';

import { logger } from '../../lib/logger';
import { useCurrentNode, useNarrativeState } from '../../store/hooks';
import { FinalSequenceEditor } from '../FinalSequenceEditor';

import { MemoryRecallSection } from './MemoryRecallSection';
import { WorldPathEditor } from './WorldPathEditor';

const conditionalLogger = logger.child('[ConditionalNodeEditor]');

export const ConditionalNodeEditor = React.memo(function ConditionalNodeEditor() {
  const narrativeState = useNarrativeState();
  const currentNode = useCurrentNode();
  const currentNodeId = narrativeState.currentNodeId;

  conditionalLogger.debug('Rendered');

  if (!currentNode) {
    return null;
  }

  // Handle world-variant nodes (new parallel world structure)
  if (currentNodeId === 'S3A_NPC_Recall_Positive' || currentNodeId === 'S3B_NPC_Recall_Negative') {
    return (
      <div className="h-full overflow-y-auto pr-2">
        <FinalSequenceEditor />
      </div>
    );
  }

  const world = currentNode.segmentId === '3A' ? 'goodWorld' : 'badWorld';

  return (
    <div className="h-full overflow-y-auto pr-2">
      <div className="space-y-6">
        <MemoryRecallSection world={world} />
        <WorldPathEditor world={world} />
      </div>
    </div>
  );
});
